/* mjade-gift-drawer — 서랍 푸터 맨 위 «기프트 패키지» 줄 (2026-09-18 v2)
 * ① 요소를 만든다 (테마 DOM 은 안 건드린다 — 하나 더할 뿐)
 * ② 여닫힘 높이를 «픽셀로» 넣는다 — grid-template-rows 애니메이션이 안 먹는 브라우저에서도 같다
 * ③ 서랍이 뜨면 자동으로 펼쳤다가 1.2초 뒤 접는다 (일본 정본 HOLD=1200)
 */
(function () {
  "use strict";
  if (window.__mjGiftDrawer) return;
  window.__mjGiftDrawer = true;

  var TEXT  = 'Every order arrives in <b>MJade gift packaging</b>.';
  var LABEL = 'MJade gift packaging';
  var HOLD  = 1200;

  function wrapOf(g){ return g ? g.querySelector('.mjc-gift__wrap') : null; }

  /* 펼친 높이 = 그림 높이 + 그림의 윗여백. 그림은 aspect-ratio 라 «다 받기 전» 에도 높이를 안다. */
  function openHeight(w){
    var img = w.firstElementChild;
    if (!img) return w.scrollHeight;
    var mt = parseFloat(getComputedStyle(img).marginTop) || 0;
    return Math.round(img.getBoundingClientRect().height + mt);
  }
  function setOpen(g, on){
    var w = wrapOf(g);
    if (!w) return;
    if (on){
      g.classList.add('is-open');
      g.setAttribute('aria-expanded', 'true');
      w.style.height = openHeight(w) + 'px';
    } else {
      /* 지금 높이로 못박고 -> 리플로우 -> 0. 이 순서라야 접히는 것이 보인다. */
      w.style.height = w.getBoundingClientRect().height + 'px';
      void w.offsetWidth;
      g.classList.remove('is-open');
      g.setAttribute('aria-expanded', 'false');
      w.style.height = '0px';
    }
  }
  function toggle(g){ setOpen(g, !g.classList.contains('is-open')); }

  function build() {
    var foot = document.querySelector('cart-drawer .cart-drawer__footer');
    if (!foot) return;
    if (foot.querySelector('.mjc-gift')) return;

    var g = document.createElement('div');
    g.className = 'mjc-gift';
    g.setAttribute('role', 'button');
    g.setAttribute('tabindex', '0');
    g.setAttribute('aria-expanded', 'false');
    g.innerHTML =
      '<span class="mjc-gift__head"><span>' + TEXT + '</span>' +
      '<i class="mjc-gift__x" aria-hidden="true"></i></span>' +
      '<span class="mjc-gift__wrap"><span class="mjc-gift__img" role="img" ' +
      'aria-label="' + LABEL + '"></span></span>';

    g.addEventListener('click', function(){ toggle(g); });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(g); }
    });
    try { foot.insertBefore(g, foot.firstChild); } catch (e) {}
  }

  /* 폭이 바뀌면 펼친 높이도 달라진다 — 열려 있으면 다시 잰다 */
  window.addEventListener('resize', function(){
    var g = document.querySelector('.mjc-gift');
    if (g && g.classList.contains('is-open')){
      var w = wrapOf(g);
      if (w) w.style.height = openHeight(w) + 'px';
    }
  });

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', build);
  else build();
  document.addEventListener('shopify:section:load', build);
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(window.__mjGiftT);
      window.__mjGiftT = setTimeout(build, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ③ 자동 펼침 — 일본 정본(theme.liquid 1644~1680) 그대로.
     한국 실측: 0.2초 펼침 -> 0.6초 완전 펼침 -> 1.4초 접기 시작 -> 2.0초 접힘. */
  var timer = null, wasOpen = false;
  function drawerOpen(){
    var d = document.querySelector('cart-drawer');
    if (!d) return false;
    var r = d.getBoundingClientRect();
    return r.width > 10 && getComputedStyle(d).visibility !== 'hidden';
  }
  setInterval(function(){
    var open = drawerOpen();
    if (open && !wasOpen){
      wasOpen = true;
      var g = document.querySelector('.mjc-gift');
      if (g){
        setOpen(g, true);
        if (timer) clearTimeout(timer);
        timer = setTimeout(function(){
          var gg = document.querySelector('.mjc-gift');
          if (gg) setOpen(gg, false);
        }, HOLD);
      }
    } else if (!open && wasOpen){
      wasOpen = false;
      if (timer){ clearTimeout(timer); timer = null; }
    }
  }, 250);
})();
